import { Expose, Transform } from "class-transformer";
import { ValuationStatusEnum } from "@altertec_gparn/lib";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class SetValuationStatusDto {
  @Expose()
  valuationId: string;

  @Expose()
  status: ValuationStatusEnum;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  registrationDate?: Date;
}
